module.exports = __webpack_public_path__ + "static/media/Cafe_1.3cd15cea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outskirts/cafe/Cafe_1.png
// module id = 1319
// module chunks = 3